module.exports = __webpack_public_path__ + "img/STERiJECT_02.bcd249cb.png";